// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main.expanded[data-v-dcc333a0]{margin-left:56px}main.reduced[data-v-dcc333a0]{margin-left:256px}main #main-container-formula[data-v-dcc333a0]{height:calc(100vh - 208px);overflow-y:hidden}#formula-card[data-v-dcc333a0]{overflow-y:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
